<template>
  <div>
    <Header :title="'スカウト件数調査'" />
    <div
      class="boss-admin-container clearfix"
      style="margin-left:-170px"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/components/templates/Header'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    Header
  },
  beforeRouteLeave (to, _from, next) {
    // スカウト件数調査ユーザー以外は画面遷移を許す
    // スカウト件数調査ユーザーはログイン画面以外への画面遷移をブロックする
    //  - ここでブロックできるのはrouterでの遷移のみ。URL直入力は防げないが、内部ユーザーのため許容範囲とする
    if (!this.isCountScoutUserSimulation || to.name === 'Login') { next() }
    next(false)
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    isCountScoutUserSimulation () {
      return _.get(this.currentUser, 'permissions.isCountScoutUserSimulation')
    }
  },
  created () {
    const masters = [
      'genders',
      'educationalBackgrounds',
      'educationalDepartments',
      'prefectures',
      'occupations',
      'businesses',
      'languages',
      'languageSkills',
      'skills',
      'licenses',
      'workStyles'
    ]
    masters.forEach(element => {
      this.storeMaster(element)
    })
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
